import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NotifierService } from 'src/app/shared/services';

@Injectable({
  providedIn: 'root'
})
export class ErrorsService {

  constructor(private notifier: NotifierService) { }
  validityError(form: any) {
    Object.keys(form.controls).forEach(x => {
      form.controls[x].markAsDirty()
      // if(form.controls[x].errors){
      //   Object.keys(form.controls[x].errors).forEach(err=>{
      //     if(err=="required"){
      //     this.notifier.error(x+" field is "+err ||"not valid form");}
      //     else if(err=="minlength" || err=="maxlength"){
      //       this.notifier.error(x+" should meet required length"||"not valid form");
      //     } else if(err=="pattern"){
      //       this.notifier.error(x+" should meet required pattern"||"not valid form");
      //     } else if(err=="min" || err=="max"){
      //       this.notifier.error(x+" should meet required range"||"not valid form");
      //     }
      //   })
      //   }
    });

  }
  catchError(err: any) {
    if (err.status == 400) {
      this.notifier.error(
        err.error?.message || err.message || "Enter valid data "
      );
    } else if (err.status == 500) {
      this.notifier.error(
        err.error?.message || err.message || "server side error"
      );
    }
    else {
      this.notifier.error(err.error?.message || err.message || 'Something went wrong')
    }
  }
  public cleanForm(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key) => {
      if (typeof (formGroup.get(key)?.value) === 'string')
        formGroup.get(key)?.setValue(formGroup.get(key)?.value.trim())
    });
  }
}
